import React from 'react';
import WindowComponent from './window_component';
import ConversationCreator from './conversation_creator';
import Conversation from './conversation';
import PropTypes from 'prop-types';
import { NEW_MESSAGE } from '../reducers/messenger_reducers';

const MARGIN_RIGHT = 31;

const ChildWindows = ({
  conversationWindows,
  handleNewConversationWindow,
  handleClose,
  convoList,
  creator,
  dispatchConversationListAction,
  handleTotalUnreadCount,
  inputRef
}) => {
  return (
    conversationWindows.map((convo, idx) => {
      const windowProps = {
        id: convo.id,
        positionRight: (idx + 1) * MARGIN_RIGHT,
        close: handleClose
      };
      return convo.type === NEW_MESSAGE ? (
        <WindowComponent key={convo.id} header={NEW_MESSAGE} {...windowProps}>
          <ConversationCreator
            id={convo.id}
            open={handleNewConversationWindow}
            close={handleClose}
            dispatchConversationListAction={dispatchConversationListAction}
            inputRef={inputRef}
          />
        </WindowComponent>
      ) : (
        <WindowComponent
          key={convo.id}
          header={null}
          orderedNames={convo.orderedNames}
          avatars={convo.avatars}
          {...windowProps}
        >
          <Conversation
            id={convo.id}
            conversationInfo={convo}
            creator={creator}
            convoList={convoList}
            dispatchConversationListAction={dispatchConversationListAction}
            handleTotalUnreadCount={handleTotalUnreadCount}
          />
        </WindowComponent>
      );
    })

  )
}

ChildWindows.propTypes = {
  conversationWindows: PropTypes.array.isRequired,
  handleNewConversationWindow: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  dispatchConversationListAction: PropTypes.func.isRequired,
  creator: PropTypes.object.isRequired,
}

export default ChildWindows
